var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayaction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.1665 4.42457C4.1665 3.61527 4.1665 3.21062 4.33525 2.98756C4.48225 2.79323 4.70694 2.67298 4.95017 2.65846C5.22937 2.64178 5.56605 2.86625 6.23944 3.31517L15.0024 9.15714C15.5588 9.52806 15.837 9.71356 15.9339 9.94731C16.0188 10.1517 16.0188 10.3814 15.9339 10.5858C15.837 10.8196 15.5588 11.005 15.0024 11.376L6.23944 17.2179C5.56605 17.6668 5.22937 17.8913 4.95017 17.8746C4.70694 17.8601 4.48225 17.7399 4.33525 17.5456C4.1665 17.3225 4.1665 16.9178 4.1665 16.1086V4.42457Z",
    fill: "#2BB219",
    stroke: "#2BB219",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayaction);
export default __webpack_public_path__ + "static/media/playaction.173d4cec985cd3a046edcc1cec90e9e1.svg";
export { ForwardRef as ReactComponent };